import { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { AppShell } from "@/components/AppShell";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function AdminSubscriptions() {
  const [subs, setSubs] = useState(null);

  useEffect(() => {
    api.get("/admin/subscriptions")
      .then((r) => setSubs(r.data))
      .catch((e) => { toast.error(formatApiError(e)); setSubs([]); });
  }, []);

  return (
    <AppShell variant="admin">
      <div className="max-w-6xl mx-auto p-5 lg:p-10" data-testid="admin-subs">
        <div className="text-xs font-semibold text-[#1E3A8A] uppercase tracking-wider">Abonelikler</div>
        <h1 className="mt-2 font-display text-3xl font-bold tracking-tight text-zinc-900">
          Abonelik Durumları
        </h1>
        <p className="mt-2 text-zinc-600">Kullanıcı abonelik kayıtlarının özeti.</p>

        <div className="mt-8 rounded-2xl border border-zinc-200 bg-white overflow-hidden">
          {subs === null && (
            <div className="p-10 text-center text-zinc-500">
              <Loader2 className="w-4 h-4 animate-spin mx-auto" />
            </div>
          )}
          {subs && subs.length === 0 && (
            <div className="p-10 text-center text-zinc-500">Kayıt yok</div>
          )}
          {subs && subs.length > 0 && (
            <div className="overflow-x-auto">
              <table className="w-full text-sm">
                <thead className="bg-zinc-50 border-b border-zinc-200">
                  <tr className="text-left text-xs uppercase tracking-wider text-zinc-500">
                    <th className="px-4 py-3 font-semibold">Kullanıcı</th>
                    <th className="px-4 py-3 font-semibold">Plan</th>
                    <th className="px-4 py-3 font-semibold">Durum</th>
                    <th className="px-4 py-3 font-semibold">Sağlayıcı</th>
                    <th className="px-4 py-3 font-semibold">Güncelleme</th>
                  </tr>
                </thead>
                <tbody>
                  {subs.map((s) => (
                    <tr key={s.id} className="border-b border-zinc-100 last:border-0">
                      <td className="px-4 py-3">
                        <div className="font-medium text-zinc-900">{s.user_name || "—"}</div>
                        <div className="text-xs text-zinc-500">{s.user_email || s.user_id}</div>
                      </td>
                      <td className="px-4 py-3">
                        <span className={`text-xs px-2 py-0.5 rounded-full ${
                          s.plan === "premium" ? "bg-[#1E3A8A]/10 text-[#1E3A8A]" : "bg-zinc-100 text-zinc-700"
                        }`}>
                          {s.plan === "premium" ? "Premium" : "Ücretsiz"}
                        </span>
                      </td>
                      <td className="px-4 py-3 text-zinc-600 capitalize">{s.status}</td>
                      <td className="px-4 py-3 text-zinc-600">{s.provider || "—"}</td>
                      <td className="px-4 py-3 text-xs text-zinc-500">
                        {new Date(s.updated_at).toLocaleString("tr-TR")}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </AppShell>
  );
}
